<template>
    <DropdownSlot
        v-if="dropdown"
        @open="onOpen"
        :label="text"
        :name="label"
        :icon="icon"
        :cls="'range-item ' + dropdownCls"
        :keepOpen="isMobileSize"
        :inner_cls="'range-input-parent ' + inner_cls"
        :dropdownIcon="dropdownIcon"
    >
        <template v-for="(option, index) in args.options" :key="index">
            <div :class="'input-container input_' + index">
                <p class="input-label" v-if="showLabel">
                    {{ index === 0 ? args.minTitle : args.maxTitle }}
                </p>
                <NumberInput
                    ref="input"
                    type="tel"
                    :mask="mask"
                    v-model:value="values[index]"
                    :placeholder="index === 0 ? minTitle : maxTitle"
                    @focus="focusIndex = index"
                    @change="onChange"
                    @enter="select(index, $event)"
                    :maxlength="maxlength"
                />
                <ul
                    :class="
                        'list-panel panel-style' +
                            (focusIndex !== -1 && focusIndex !== index
                                ? ' disabled'
                                : '')
                    "
                >
                    <li
                        :title="$t('any')"
                        data-value
                        @click="select(index, '')"
                    >
                        <span>{{ $t('any') }}</span>
                    </li>
                    <li
                        v-for="(item, idx) in option"
                        :key="idx"
                        @click="select(index, item.value)"
                        :class="{ 'active': item.value == values[index] }"
                    >
                        <span>{{ prefix }}{{ $ft.formatNum(item.label) }}</span>
                    </li>
                </ul>
            </div>
            <span v-if="index === 0" class="price-line"></span>
        </template>
    </DropdownSlot>
    <div v-else :class="dropdownCls">
        <template v-for="index in [0, 1]" :key="index">
            <div :class="'input-container input_' + index">
                <NumberInput
                    ref="input"
                    type="tel"
                    :mask="mask"
                    v-model:value="values[index]"
                    :placeholder="index === 0 ? minTitle : maxTitle"
                    @focus="focusIndex = index"
                    @blur="focusIndex = -1"
                    @change="onChange"
                    @enter="select(index, $event)"
                    :maxlength="maxlength"
                />
            </div>
            <span v-if="index === 0" class="price-line"></span>
        </template>
    </div>
</template>
<script>
import { mapState } from 'pinia';
import { usePageStore } from '@/store';
import DropdownSlot from './dropdown-slot.vue';
import NumberInput from './numberInput.vue';
import { numberFormat, formatUnitsNumber } from '../common/format';
import util from '../common/util';
import { defaultLngCode } from '@/globalization/constant.js';
export default {
    i18next: {
        ns: 'common'
    },
    emits: ['change', 'open'],
    props: [
        'label',
        'icon',
        'kee',
        'args',
        'mask',
        'cls',
        'inner_cls',
        'dropdown',
        'inMore',
        'emptyLabel',
        'value',
        'dropdownIcon',
        'maxlength',
        'showLabel',
        'keepOpen',
        'heroCenter'
    ],
    components: { DropdownSlot, NumberInput },
    data: function() {
        return {
            values: { 0: '', 1: '' },
            split: ',',
            focusIndex: -1
        };
    },
    computed: {
        ...mapState(usePageStore, {
            currentLanguage: store => store.currentLanguage,
            currencySymbol: store => store.currency.symbol,
            currencyRate: store => store.currencyRate,
            currencyAbbr: store => store.currency.abbr, //  Short for current currency
            baseCurrency: store => store.baseCurrency //  base currency , USD
        }),
        isMobileSize() {
            return this.platform.isMobile && window.innerWidth < 800;
        },
        isCurCurrencyEqualBaseCurrency() {
            //  Determine whether the currently selected currency is equal to the base currency
            return this.currencyAbbr === this.baseCurrency;
        },
        prefix({ mask, currencySymbol }) {
            return mask === 'money' ? `${currencySymbol} ` : '';
        },
        minTitle({ args, currentLanguage }) {
            if (currentLanguage == defaultLngCode) {
                return args.minTitle;
            }
            return this.$t('common:min');
        },
        maxTitle({ args, currentLanguage }) {
            if (currentLanguage == defaultLngCode) {
                return args.maxTitle;
            }
            return this.$t('common:max');
        },
        formattedValues() {
            return [this.values[0], this.values[1]].map(v =>
                v ? this.format(v) : '');
        },
        labels() {
            return [
                this.values[0]
                    ? this.args.minLabel
                        ? this.args.minLabel.replace(
                            '${value}',
                            this.format(this.values[0], true),
                            true
                        )
                        : ''
                    : '',
                this.values[1]
                    ? this.args.maxLabel
                        ? this.args.maxLabel.replace(
                            '${value}',
                            this.format(this.values[1], true),
                            true
                        )
                        : ''
                    : ''
            ];
        },
        text() {
            let values = [this.values[0], this.values[1]];
            if (this.mask === 'money') {
                if (this.labels[0] && this.labels[1]) {
                    if (values[0] === values[1]) {
                        return this.format(values[0], true);
                    }
                    return values.map(v => this.format(v, true)).join('-');
                } else {
                    return (
                        this.labels[0] ||
                        this.labels[1] ||
                        this.emptyLabel ||
                        this.label
                    );
                }
            } else {
                if (this.labels[0] && this.labels[1]) {
                    if (this.formattedValues[0] === this.formattedValues[1]) {
                        return (
                            this.formattedValues[0] +
                            ' ' +
                            (values[0] > 1
                                ? this.label
                                : this.label.replace(/s$/, ''))
                        );
                    }
                    return this.formattedValues.join('-') + ' ' + this.label;
                } else {
                    if (!this.labels[0] && !this.labels[1]) {
                        return this.emptyLabel || this.label;
                    } else if (this.heroCenter) {
                        // md-hero baths beds
                        let minLabel = '';
                        let maxLabel = '';
                        if (this.labels[0]) {
                            minLabel = this.args.minLabel.replace(
                                '#min_value#',
                                values[0]
                            );
                        }
                        if (this.labels[1]) {
                            maxLabel = this.args.maxLabel.replace(
                                '#max_value#',
                                values[1]
                            );
                        }

                        return minLabel || maxLabel || this.label;
                    } else {
                        if (!this.labels[0]) {
                            return (
                                'Any-' +
                                this.formattedValues[1] +
                                '' +
                                this.label
                            );
                        }
                        return this.formattedValues[0] + '+ ' + this.label;
                    }
                }
            }
        },
        dropdownCls({ cls, value }) {
            let temp = [cls]
            if (value) {
                temp.push('active')
            }
            return temp.join(' ')
        }
    },
    methods: {
        select(index, value) {
            this.values[index] = '' + value;
            this.onChange();
            this.autoFocus();
        },
        onOpen() {
            this.autoFocus();
            this.$emit('open');
        },
        onChange() {
            this.swap();
            let value = '';
            if (this.values[0] || this.values[1]) {
                value = this.values[0] + this.split + this.values[1];
            }
            this.$emit('change', {
                kee: this.kee,
                value: value,
                labels: this.labels,
                type: 'range',
                split: this.split,
                inMore: this.inMore
            });
        },
        swap() {
            if (
                this.values[0] &&
                this.values[1] &&
                +this.values[0] > +this.values[1]
            ) {
                let temp = this.values[0];
                this.values[0] = this.values[1];
                this.values[1] = temp;
            }
        },
        autoFocus() {
            setTimeout(() => {
                if (!this.values[0]) {
                    this.$refs.input[0].setFocus();
                } else if (!this.values[1]) {
                    this.$refs.input[1].setFocus();
                }
            }, 0);
        },
        format(v, units) {
            if (this.mask === 'money') {
                if (units) {
                    return `${this.currencySymbol}` + formatUnitsNumber(v);
                }
                return `${this.currencySymbol} ` + numberFormat(v, false);
            }
            return numberFormat(v, false);
        }
    },
    created() {
        this.onChange = util.debounce(this.onChange);
    },
    watch: {
        value: {
            immediate: true,
            handler: function() {
                let values = this.value.split(this.split);
                // console.log(' old and new prices  ===>>>',values, this.values)
                if (
                    (this.mask === 'money' || this.mask === 'dollar') &&
                    !this.isCurCurrencyEqualBaseCurrency
                ) {
                    if (!this.values[0]) {
                        this.values[0] = util.transferDollarToCurrency({
                            price: values[0] || '',
                            isInt: true,
                            currencyRate: this.currencyRate
                        });
                    } else {
                        let current$ = util.transferPriceToDollar({
                            price: this.values[0],
                            isInt: true,
                            currencyRate: this.currencyRate
                        }); //  Transfer base currency
                        if (Number(current$) != Number(values[0])) {
                            this.values[0] = util.transferDollarToCurrency({
                                price: values[0] || '',
                                isInt: true,
                                currencyRate: this.currencyRate
                            });
                        }
                    }
                    if (!this.values[1]) {
                        this.values[1] = util.transferDollarToCurrency({
                            price: values[1] || '',
                            isInt: true,
                            currencyRate: this.currencyRate
                        });
                    } else {
                        let current$ = util.transferPriceToDollar({
                            price: this.values[1],
                            isInt: true,
                            currencyRate: this.currencyRate
                        });
                        if (Number(current$) != Number(values[1])) {
                            this.values[1] = util.transferDollarToCurrency({
                                price: values[1] || '',
                                isInt: true,
                                currencyRate: this.currencyRate
                            });
                        }
                    }
                    return;
                }
                this.values[0] = values[0] || '';
                this.values[1] = values[1] || '';
                // if (this.value) {
                //     this.onChange();
                // }
            }
        }
    }
};
</script>
